/**
 * Helpers to resolve the currently authenticated admin's display email.
 *
 * The active auth/me endpoint can return only `username` with no
 * `email`/`user_email`, which leaves `adminEmail` in AppContext as `null`.
 * Login stores the submitted email in `localStorage["email"]`, so consumers
 * that need email identity can use `readStoredAdminEmail()`. The Header then
 * falls back to username only for display; that username fallback should not be
 * used as an email identity.
 */

const STORED_EMAIL_KEY = "email";

export const isEmailAddress = (value) =>
  typeof value === "string" && value.includes("@");

export const readStoredAdminEmail = () => {
  try {
    const raw = localStorage.getItem(STORED_EMAIL_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return isEmailAddress(parsed) ? parsed : null;
  } catch {
    // localStorage value may be a plain string (not JSON-encoded) on older
    // sessions.
    const storedEmail = localStorage.getItem(STORED_EMAIL_KEY);
    return isEmailAddress(storedEmail) ? storedEmail : null;
  }
};
